// CSButton.js
import React, { forwardRef } from "react";
import styles from "./CSButton.module.css";

const CSButton = forwardRef(function CSButton(props, ref) {
  const {
    as: Comp = "button",
    children,
    variant = "",
    className = "",
    type = "button", // Default to button type to prevent form submission
    ...rest
  } = props;

  const variantClasses = variant
    .split(" ")
    .map((v) => styles[v])
    .filter(Boolean);

  const classList = [styles.button, ...variantClasses, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Comp ref={ref} className={classList} type={type} {...rest}>
      {children}
    </Comp>
  );
});

export default CSButton;
